import ReactHtmlParser from "react-html-parser";

const HtmlDiv = ({ htmlString = "" }) => ReactHtmlParser(htmlString);

export default HtmlDiv;
